// extracted by css-extract-rspack-plugin
export default {"popupBackdrop":"_3RYfv","popupContent":"_1M89N","closeButton":"_2CbL3"};